import { Button } from "Components/ui/button";
import { useEffect, useState } from "react";
import "./ChallengeBilling.scss";

import { useAuth } from "@clerk/clerk-react";
import { Separator } from "Components/ui/separator";
import {
  ChevronDown,
  CircleCheckBig,
  CircleX,
  ClipboardIcon,
  TicketPercent,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  checkPromoFunction,
  checkWelcomePromoFunction,
  clearPromo,
  createChallenge,
  createDraft,
  createWelcomeDraft,
  initPayablePayment,
} from "../../Redux/ChallengeSetup/ChallengeSetupAction";
import {
  clearAllStatesses,
  createInvoice,
  getCryptoChillProfile,
  getInvoice,
  getInvoiceQr,
  getRates,
} from "../../Redux/CryptoChill/CryptoChillAction";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "Components/ui/accordion";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "Components/ui/dialog";
import { Input } from "Components/ui/input";
import { Skeleton } from "Components/ui/skeleton";
import useCountdown from "hooks/use-countDown";
import UseInnerWidth from "hooks/UseInnerWidth";
import { io } from "socket.io-client";
import { toast } from "sonner";
import trailDots from "../../Assets/Images/trailDots.svg";
import InfoDialog from "./PaymentsProviders/InfoDialog";
import {
  createPurchaseSession,
  createPurchaseSessionNew,
  getPublishableKeyAction,
} from "../../Redux/PaymentsPurchase/PaymentPurchaseActions";

function BillingSummary({
  challengeType,
  accountBalance,
  accountType,
  selectedPlatform,
  selectedCurrency,
  paymentMethod,
  selectedAddon,
  currency,
  total,
  all,
  paymentProvider,
  setPaymentProvider,
  done,
}) {
  const {
    profile,
    rates,
    createInvoiceSuccess,
    invoice,
    qrCode,
    createInvoiceLoading,
    getRatesLoading,
    getQRCodeLoading,
    getInvoiceLoading,
    getProfileLoading,
  } = useSelector((state) => state.InvoiceReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.ProfileReducer);
  const [kind, setKind] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const { createDraftSuccess } = useSelector(
    (state) => state.ChallengeSetupReducer
  );

  const [promo, setPromo] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);

  const [step, setStep] = useState(1);
  const { getToken } = useAuth();
  const [open, setOpen] = useState(false);
  const [affiliateId, setAffiliateId] = useState(null);

  const {
    payablePayment,
    payablePaymentSuccess,
    payablePaymentLoading,
    createDraftLoading,
    createChallengeLoading,
    checkPromoSuccess,
    checkPromoError,
    checkPromoLoading,
    checkPromo,
  } = useSelector((state) => state.ChallengeSetupReducer);
  const [challengeInfo, setChallengeInfo] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const [openFinal, setOpenFinal] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [info, setInfo] = useState({});

  const [ip, setIp] = useState("");
  const {
    createPurchaseSessionError,
    createPurchaseSessionLoading,
    createPurchaseSessionSuccess,
  } = useSelector((state) => state.PaymentPurchaseReducer);
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIp(data.ip))
      .catch((error) => console.error("Error fetching IP address:", error));
    dispatch(getPublishableKeyAction(getToken));
  }, []);

  useEffect(() => {
    if (searchParams.get("affiliateId")) {
      setAffiliateId(searchParams.get("affiliateId"));
    }
  }, [searchParams.get("affiliateId")]);

  useEffect(() => {
    if (selectedAddon.length > 0) {
      let totalAmount = parseFloat(total);
      selectedAddon.map((addon) => {
        totalAmount += addon?.percentage;
      });
      setTotalAmount(totalAmount);
    } else {
      setTotalAmount(total);
    }
  }, [selectedAddon, total]);

  const handlePayment = async () => {
    if (all) {
      setOpenInfo(true);
    } else {
      if (paymentMethod === "CC") {
        if (paymentProvider == "STRIPE") {
          handleStripe();
        }
      } else if (paymentMethod === "wallet") {
        dispatch(
          createChallenge(
            getToken,
            {
              challengeTypeId: challengeType,
              currencyId: selectedCurrency?.value,
              platformId: selectedPlatform,
              balanceId: accountBalance,
              code: checkPromo?.code || null,
              accountTypeId: accountType,
              isFree: false,
              ...(selectedAddon?.length > 0 && {
                addons: selectedAddon.map((addon) => addon?.id).join(","),
              }),
            },
            navigate
          )
        );
      } else {
        setPaymentStatus("");
        setStep(1);
        setOpen(true);
        restart();
        dispatch(
          getCryptoChillProfile(
            getToken,
            process.env.REACT_APP_CRYPTO_CHALLENGE
          )
        );
        dispatch(getRates(getToken));
      }
    }
  };

  useEffect(() => {
    if (payablePayment && payablePaymentSuccess) {
      const url = payablePayment?.url;
      if (url) window.location.href = url;
    }
  }, [payablePayment, payablePaymentSuccess]);

  useEffect(() => {
    if (createDraftSuccess && all) {
      const passthroughData = {
        challenge_id: createDraftSuccess?.id,
        type: "Start",
      };
      dispatch(
        createInvoice(getToken, {
          amount: createDraftSuccess?.total?.toString(),
          currency: currency,
          kind: kind,
          profile_id: process.env.REACT_APP_CRYPTO_CHALLENGE,
          passthrough: JSON.stringify(passthroughData),
        })
      );
    } else {
      if (createDraftSuccess) {
        const passthroughData = { challenge_id: createDraftSuccess?.id };
        dispatch(
          createInvoice(getToken, {
            amount: createDraftSuccess?.total?.toString(),
            currency: currency,
            kind: kind,
            profile_id: process.env.REACT_APP_CRYPTO_CHALLENGE,
            passthrough: JSON.stringify(passthroughData),
          })
        );
      }
    }
  }, [createDraftSuccess, all]);

  useEffect(() => {
    if (createInvoiceSuccess) {
      dispatch(getInvoice(getToken, createInvoiceSuccess?.result?.id));
      dispatch(getInvoiceQr(getToken, createInvoiceSuccess?.result?.id));
      setStep(2);
      SocketIo.emit("joinInvoiceRoom", {
        invoiceId: createInvoiceSuccess?.result?.id,
      });
      SocketIo.on("invoice-update", (data) => {
        setPaymentStatus(data.status);
        setChallengeInfo({
          state: data?.data?.status,
          type: data?.data?.type,
          id: data?.data?.challengeId,
          login: data?.data?.login,
          balance: data?.data?.balance,
          drawdown: data?.data?.drawdown,
        });
      });
    }
  }, [createInvoiceSuccess]);

  const { formattedTime, progress, restart } = useCountdown(
    invoice?.result?.expires_at
  );

  useEffect(() => {
    if (!open) {
      dispatch(clearAllStatesses());
    }
  }, [open]);

  const handleCloseDialog = () => {
    if (paymentStatus == "complete" && all) {
      if (challengeInfo?.state == "Success")
        navigate(
          `/createdSuccessfully?type=${challengeInfo?.type}&balance=${challengeInfo?.balance}&login=${challengeInfo?.login}&drawdown=${challengeInfo?.drawdown}&id=${challengeInfo?.id}`
        );
      else
        navigate(
          `/inProgressCreation?type=${challengeInfo?.type}&balance=${challengeInfo?.balance}`
        );
    } else {
      if (paymentStatus == "complete") {
        // Navigate to home page
        if (challengeInfo?.state == "Success")
          navigate(
            `/createdSuccessfully?type=${challengeInfo?.type}&balance=${challengeInfo?.balance}&login=${challengeInfo?.login}&drawdown=${challengeInfo?.drawdown}&id=${challengeInfo?.id}`
          );
        else
          navigate(
            `/inProgressCreation?type=${challengeInfo?.type}&balance=${challengeInfo?.balance}`
          );
      }
    }
    setOpen(false); // Close the dialog
  };

  const width = UseInnerWidth();

  const handleCrypto = (currenci) => {
    setKind(currenci?.kind);
    const data = {
      challengeTypeId: challengeType,
      currencyId: selectedCurrency?.value,
      platformId: selectedPlatform,
      balanceId: accountBalance,
      code: checkPromo?.code || null,

      accountTypeId: accountType,
      isFree: false,
      transactionId: payablePayment?.transactionId,
      addons: selectedAddon.map((addon) => addon?.id).join(",") || undefined,
    };

    Object.keys(data).forEach(
      (key) => data[key] === undefined && delete data[key]
    );

    if (all) {
      dispatch(
        createWelcomeDraft({
          ...data,
          firstName: info.firstName,
          lastName: info.lastName,
          email: info.email,
          partnerId: affiliateId || null,
        })
      );
    } else {
      dispatch(createDraft(getToken, data));
    }
  };

  useEffect(() => {
    if (paymentStatus) {
      setOpenFinal(true);
      setOpen(false);
    }
  }, [paymentStatus]);

  const handleNewCreate = () => {
    if (paymentMethod === "CC") {
      // if (paymentProvider == "PAYABL") {
      //   handlePayable(true);
      // } else {
      if (paymentProvider == "STRIPE") {
        handleStripe(true);
      }
      // }
    } else if (paymentMethod === "wallet") {
      dispatch(
        createChallenge(
          getToken,
          {
            challengeTypeId: challengeType,
            currencyId: selectedCurrency?.value,
            platformId: selectedPlatform,
            balanceId: accountBalance,
            code: checkPromo?.code || null,
            accountTypeId: accountType,
            isFree: false,
            ...(selectedAddon?.length > 0 && {
              addons: selectedAddon.map((addon) => addon?.id).join(","),
            }),
          },
          navigate
        )
      );
    } else {
      setPaymentStatus("");
      setStep(1);
      setOpen(true);
      setOpenInfo(false);
      restart();
      dispatch(
        getCryptoChillProfile(getToken, process.env.REACT_APP_CRYPTO_CHALLENGE)
      );
      dispatch(getRates(getToken));
    }
  };

  const handleStripe = (all) => {
    if (all) {
      dispatch(
        createPurchaseSessionNew(
          {
            challengeTypeId: challengeType,
            currencyId: selectedCurrency?.value,
            platformId: selectedPlatform,
            balanceId: accountBalance,
            partnerId: affiliateId || null,

            code: checkPromo?.code || null,
            firstName: info.firstName,
            lastName: info.lastName,
            email: info.email,
            accountTypeId: accountType,
            isFree: false,
            ...(selectedAddon?.length > 0 && {
              addons: selectedAddon.map((addon) => addon?.id).join(","),
            }),
          },
          navigate
        )
      );
    } else
      dispatch(
        createPurchaseSession(
          getToken,
          {
            challengeTypeId: challengeType,
            currencyId: selectedCurrency?.value,
            platformId: selectedPlatform,
            balanceId: accountBalance,
            code: checkPromo?.code || null,
            accountTypeId: accountType,
            isFree: false,
            ...(selectedAddon?.length > 0 && {
              addons: selectedAddon.map((addon) => addon?.id).join(","),
            }),
          },
          navigate
        )
      );
  };

  useEffect(() => {
    if (challengeType || accountBalance) {
      dispatch(clearPromo());
    }
  }, [challengeType, accountBalance]);
  return (
    <div className="flex flex-col gap-3 flex-1">
      {width < 640 ? (
        <>
          <Accordion type="single" collapsible className="w-full ">
            <AccordionItem value="item-1">
              <AccordionTrigger className="p-0">
                <div className=" text-lg font-N_Bold  flex items-center justify-between w-full">
                  Summary <ChevronDown />
                </div>
              </AccordionTrigger>
              <AccordionContent>
                <div className="flex flex-col gap-4">
                  {" "}
                  <div className="flex justify-between items-center gap-4 mt-2">
                    <div className=" text-base  text-white-opacity">
                      Challenge Creation
                    </div>
                    <div className="text-base text-white-opacity">
                      {parseFloat(total)?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })}
                    </div>
                  </div>
                  {selectedAddon.map((addon) => {
                    return (
                      <div className="flex justify-between items-center gap-2">
                        <div className=" text-base text-white-opacity">
                          {addon?.name}
                        </div>
                        <div className="text-base text-white-opacity">
                          {parseFloat(addon?.percentage)?.toLocaleString(
                            "en-US",
                            {
                              style: "currency",
                              currency: "USD",
                            }
                          )}
                        </div>
                      </div>
                    );
                  })}
                  <>
                    <Separator className=" bg-background-opacity2 h-[0.15rem] my-2" />
                    <div className="px-4 py-2 flex items-center border border-background-opacity2 rounded-lg justify-between">
                      <div className="flex items-center gap-4">
                        <TicketPercent className="text-white-opacity" />
                        <input
                          className="border-none outline-none bg-transparent placeholder:text-white-opacity text-white text-sm"
                          type="text"
                          value={promo}
                          placeholder="Discount Code"
                          onChange={(e) => setPromo(e.target.value)}
                        />
                      </div>
                      {checkPromo?.code ? (
                        <div
                          className="font-N_Medium text-white-opacity cursor-pointer hover:underline"
                          style={{
                            opacity: checkPromoLoading ? 0.5 : 1,
                          }}
                          onClick={() => dispatch(clearPromo()) && setPromo("")}
                        >
                          Clear
                        </div>
                      ) : (
                        <div
                          className="font-N_Medium text-primary cursor-pointer hover:underline"
                          style={{
                            opacity: checkPromoLoading ? 0.5 : 1,
                          }}
                          onClick={() =>
                            !checkPromoLoading &&
                            (all
                              ? dispatch(
                                  checkWelcomePromoFunction(promo, {
                                    challengeTypeId: challengeType,
                                    balanceId: accountBalance,
                                  })
                                )
                              : dispatch(
                                  checkPromoFunction(getToken, promo, {
                                    challengeTypeId: challengeType,
                                    balanceId: accountBalance,
                                  })
                                ))
                          }
                        >
                          {checkPromoLoading ? "Apply..." : "Apply"}
                        </div>
                      )}
                    </div>

                    <div className="flex justify-between items-center gap-4 mt-4">
                      <div className=" text-2xl  font-N_Medium">Total</div>
                      <div className="text-2xl font-N_Medium">
                        {checkPromo?.discount ? (
                          <div className="text-lg font-N_Medium flex items-baseline gap-2">
                            <span className="text-2xl line-through text-white-opacity">
                              {parseFloat(totalAmount)?.toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "USD",
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 3,
                                }
                              )}
                            </span>
                            {(
                              totalAmount *
                              (1 - checkPromo?.discount / 100)
                            )?.toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 3,
                            })}
                          </div>
                        ) : (
                          parseFloat(totalAmount)?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          })
                        )}
                      </div>
                    </div>
                  </>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </>
      ) : (
        <>
          {" "}
          <div className=" text-lg font-N_Bold">Summary</div>
          <div className="flex justify-between items-center gap-4 mt-2">
            <div className=" text-base  text-white-opacity">
              Challenge Creation
            </div>
            <div className="text-base text-white-opacity">
              {parseFloat(total)?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </div>
          </div>
          {selectedAddon.map((addon) => {
            return (
              <div className="flex justify-between items-center gap-2">
                <div className=" text-base text-white-opacity">
                  {addon?.name}
                </div>
                <div className="text-base text-white-opacity">
                  {parseFloat(addon?.percentage)?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </div>
              </div>
            );
          })}
        </>
      )}

      {width > 640 && (
        <>
          <Separator className=" bg-background-opacity2 h-[0.15rem] my-2" />
          <div className="px-4 py-2 flex items-center border border-background-opacity2 rounded-lg justify-between">
            <div className="flex items-center gap-4">
              <TicketPercent className="text-white-opacity" />
              <input
                className="border-none outline-none bg-transparent placeholder:text-white-opacity text-white text-sm"
                type="text"
                value={promo}
                placeholder="Discount Code"
                onChange={(e) => setPromo(e.target.value)}
              />
            </div>
            {checkPromo?.code ? (
              <div
                className="font-N_Medium text-white-opacity cursor-pointer hover:underline"
                style={{
                  opacity: checkPromoLoading ? 0.5 : 1,
                }}
                onClick={() => dispatch(clearPromo()) && setPromo("")}
              >
                Clear
              </div>
            ) : (
              <div
                className="font-N_Medium text-primary cursor-pointer hover:underline"
                style={{
                  opacity: checkPromoLoading ? 0.5 : 1,
                }}
                onClick={() =>
                  !checkPromoLoading &&
                  (all
                    ? dispatch(
                        checkWelcomePromoFunction(promo, {
                          challengeTypeId: challengeType,
                          balanceId: accountBalance,
                        })
                      )
                    : dispatch(
                        checkPromoFunction(getToken, promo, {
                          challengeTypeId: challengeType,
                          balanceId: accountBalance,
                        })
                      ))
                }
              >
                {checkPromoLoading ? "Apply..." : "Apply"}
              </div>
            )}
          </div>
          <Separator className=" bg-background-opacity2 h-[0.15rem] mt-2" />

          <div className="flex justify-between items-center gap-4 mt-4">
            <div className=" text-2xl  font-N_Medium">Total</div>
            <div className="text-2xl font-N_Medium">
              {checkPromo?.discount ? (
                <div className="text-lg font-N_Medium flex items-baseline gap-2">
                  <span className="text-2xl line-through text-white-opacity">
                    {parseFloat(totalAmount)?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 3,
                    })}
                  </span>
                  {(
                    totalAmount *
                    (1 - checkPromo?.discount / 100)
                  )?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 3,
                  })}
                </div>
              ) : (
                parseFloat(totalAmount)?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 3,
                })
              )}
            </div>
          </div>
        </>
      )}

      <div className="flex flex-col  items-center justify-center gap-2 mt-4">
        <Button
          onClick={() => handlePayment()}
          disabled={
            !(
              challengeType &&
              selectedCurrency &&
              selectedPlatform &&
              accountType &&
              accountBalance
            ) ||
            createChallengeLoading ||
            payablePaymentLoading ||
            createPurchaseSessionLoading ||
            !done
          }
          className="w-full"
        >
          {payablePaymentLoading ||
          createChallengeLoading ||
          createPurchaseSessionLoading
            ? "Processing Payment"
            : "Confirm Payment"}
        </Button>
        <div
          className="w-fit text-sm text-white-opacity hover:underline hover:text-white cursor-pointer"
          onClick={() => navigate("/")}
        >
          Cancel
        </div>
      </div>
      <div className="sm:block hidden">
        <Separator className="bg-border-darkNew mt-2 " />

        <p className="text-white-opacity text-xs mt-4">
          All information provided on this site is intended solely for
          educational purposes related to trading on financial markets and does
          not serve in any way as a specific investment recommendation, business
          recommendation, investment opportunity analysis or similar general
          recommendation regarding the trading of investment instruments. The
          information on this site is not directed at residents in any country
          or jurisdiction where such distribution or use would be contrary to
          local laws or regulations. Only Funds does not act as a broker and
          does not accept any deposits. Due to the volatile nature of live
          markets, these challenges may be difficult to pass, even for
          experienced traders. As such, they are not recommended for individuals
          with little or no prior trading experience. The offered technical
          solution and data feed is powered by liquidity providers.
          <br /> Copyright © 2025 Only Funds. All rights reserved.
        </p>
      </div>
      <Dialog open={open} onOpenChange={handleCloseDialog}>
        <DialogContent className="md:max-w-[55%] max-w-[90%]  overflow-x-hidden shadow-xl">
          <DialogTitle className="text-2xl font-N_Bold">
            Finalize your payment
          </DialogTitle>
          {(getProfileLoading ||
            getRatesLoading ||
            getQRCodeLoading ||
            getInvoiceLoading ||
            createInvoiceLoading ||
            createDraftLoading) &&
          paymentStatus !== "complete" &&
          open ? (
            <>
              <Skeleton className="bg-border-darkNew p-6 rounded-xl w-full" />
              <Skeleton className="bg-border-darkNew p-6 rounded-xl w-full" />
            </>
          ) : (
            profile &&
            profile?.result?.currencies?.length > 0 &&
            step == 1 &&
            profile?.result?.currencies.map((currenci) => {
              const rate = rates?.result?.find((rate) => {
                if (currenci?.kind == "ETH_USDT") return rate.symbol == "USDT";
                else return rate?.symbol === currenci?.kind;
              })?.rate_usd;
              let totalAmountInCurrency;
              if (checkPromo?.discount) {
                totalAmountInCurrency = rate
                  ? (totalAmount * (1 - checkPromo?.discount / 100)) / rate
                  : 0;
              } else {
                totalAmountInCurrency = rate ? totalAmount / rate : 0;
              }
              return (
                <div
                  className="flex items-center justify-between p-4 border-2 border-border-darkNew rounded-xl cursor-pointer"
                  onClick={() => handleCrypto(currenci)}
                >
                  <span className="text-white text-sm">
                    Pay with {currenci?.kind}
                  </span>
                  <span className="text-white text-sm">
                    {totalAmountInCurrency?.toFixed(6)}
                  </span>
                </div>
              );
            })
          )}
          {step == 2 &&
          (getInvoiceLoading ||
            createInvoiceLoading ||
            getQRCodeLoading ||
            createDraftLoading) &&
          paymentStatus !== "complete" &&
          progress < 100 ? (
            <div className="flex flex-col gap-4">
              <span className="text-white-opacity text-sm">
                To complete the payment, please open your crypto wallet and
                transfer the specified amount to the address listed here.
              </span>
              <div className="w-full flex flex-row items-center gap-6">
                <div className="w-[70%] flex flex-col gap-4">
                  <Skeleton className="bg-border-darkNew p-4 rounded-xl w-full" />
                  <Skeleton className="bg-border-darkNew p-4 rounded-xl w-full" />
                  <Skeleton className="bg-border-darkNew p-4 rounded-xl w-full" />
                </div>
                <div className="w-[30%] flex flex-col gap-4">
                  <Skeleton className="bg-border-darkNew h-[150px] rounded-xl w-full" />
                </div>
              </div>
            </div>
          ) : step == 2 && paymentStatus !== "complete" && progress < 100 ? (
            <div className="flex flex-col gap-4">
              <span className="text-white-opacity text-sm">
                To complete the payment, please open your crypto wallet and
                transfer the specified amount to the address listed here.
              </span>
              <div className="w-full flex flex-row items-center gap-6">
                <div className="w-[70%] flex flex-col gap-4">
                  <div className="flex flex-col gap-1 ">
                    <label className="text-white text-sm">
                      {kind} payment address
                    </label>
                    <div className="relative">
                      <Input
                        className="pr-12"
                        type="text"
                        value={invoice?.result?.address}
                        disabled
                      />
                      <div className="absolute top-1/2 right-4 transform -translate-y-1/2 cursor-pointer">
                        <ClipboardIcon
                          className="h-4 w-4 text-white"
                          color="var(--primary)"
                          onClick={() => {
                            navigator.clipboard
                              .writeText(invoice?.result?.address)
                              .then(() => {
                                toast.success("Address Copied to clipboard");
                              })
                              .catch((err) => {
                                console.error("Failed to copy address: ", err);
                              });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col gap-1">
                    <label className="text-white text-sm">
                      Amount to sent in {kind}
                    </label>
                    <Input
                      type="text"
                      value={invoice?.result?.amount?.invoiced?.amount}
                      disabled
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <div className="flex flex-row items-center justify-between">
                      <label className="text-white text-sm">
                        Expires in {formattedTime}
                      </label>
                      <span
                        className="text-primary font-N_Roman text-sm cursor-pointer"
                        onClick={() => {
                          dispatch(
                            createInvoice(getToken, {
                              amount:
                                invoice?.result?.amount?.requested?.amount,
                              currency:
                                invoice?.result?.amount?.requested?.currency,
                              kind: invoice?.result?.amount?.invoiced?.currency,
                              profile_id: invoice?.result?.profile_id,
                              passthrough: invoice?.result?.passthrough,
                            })
                          );
                        }}
                      >
                        Renew
                      </span>
                    </div>
                    <div className="mt-2 relative">
                      <div className="w-full h-2 bg-border-darkNew rounded-full">
                        <div
                          className="h-full bg-primary rounded-full"
                          style={{ width: `${progress}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-[30%] flex flex-col justify-center items-center gap-4">
                  {" "}
                  <span className="text-white text-sm">Scan QR code</span>
                  <div
                    className="qr-code bg-white p-0"
                    dangerouslySetInnerHTML={{ __html: qrCode }}
                  />
                </div>
              </div>
            </div>
          ) : paymentStatus === "complete" ? (
            <div className="flex flex-col items-center justify-center gap-4">
              <CircleCheckBig
                color="#00ff2a"
                strokeWidth={1.5}
                width={60}
                height={60}
              />
              <div className="text-white text-lg font-N_Medium">
                Payment successful
              </div>
            </div>
          ) : progress == 100 && paymentStatus !== "complete" ? (
            <div className="flex flex-col items-center justify-center gap-4">
              <CircleX
                color="#ff0000"
                strokeWidth={1.5}
                width={60}
                height={60}
              />
              <div className="text-white text-lg font-N_Medium">
                Payment expired
              </div>
            </div>
          ) : null}
        </DialogContent>
      </Dialog>
      <Dialog
        open={openFinal}
        onOpenChange={() => {
          setOpenFinal(true);
        }}
      >
        <DialogContent
          className=" overflow-x-hidden shadow-xl
              "
        >
          <DialogHeader className="font-N_Medium text-2xl">
            Payment Status
          </DialogHeader>
          <Separator className="bg-borderChallenge w-[120%] ml-[-10%] opacity-20 h-[0.2rem] rounded-xl" />
          <DialogDescription className={`flex flex-col `}>
            <div className="flex flex-col items-start">
              <div className="flex flex-row gap-4 items-center">
                <div className="w-6 h-6 rounded-full aspect-square bg-primary"></div>
                <div className="">
                  <div className="font-N_Bold text-lg">Payment Pending</div>
                  <div className="opacity-[0.44] font-N_Roman text-base">
                    Your Payment has been received.
                  </div>
                </div>
              </div>
              {
                <img
                  src={trailDots}
                  alt={"trails"}
                  className={`ml-[0.625rem] -mt-2 -mb-2 ${
                    paymentStatus == "pending" && "opacity-[0.43]"
                  }`}
                />
              }
            </div>
            <div className="flex flex-col items-start">
              <div
                className={`${
                  paymentStatus == "pending" ? "opacity-[0.43]" : "opacity-[1]"
                } flex flex-row gap-4 items-center`}
              >
                <div className="w-6 h-6 rounded-full aspect-square bg-primary"></div>
                <div>
                  <div className="font-G_Bold text-lg">Confirmed</div>
                  <div className="opacity-[0.44] font-G_Regular text-base">
                    We’re confirming your payment details.
                  </div>
                </div>
              </div>
              {
                <img
                  src={trailDots}
                  alt={"trails"}
                  className={`ml-[0.625rem] -mt-2 -mb-2 ${
                    paymentStatus != "complete" && "opacity-[0.43]"
                  }`}
                />
              }
            </div>

            <div className="flex flex-col items-start">
              <div
                className={`${
                  paymentStatus != "complete" ? "opacity-[0.43]" : "opacity-[1]"
                } flex flex-row gap-4 items-center`}
              >
                <div className="w-6 h-6 rounded-full aspect-square bg-primary"></div>
                <div>
                  <div className="font-G_Bold text-lg">Completed</div>
                  <div className="opacity-[0.44] font-G_Regular text-base">
                    Your payment has been confirmed.
                  </div>
                </div>
              </div>
            </div>
            <Button
              className="mt-4 w-full max-w-[15rem]"
              disabled={paymentStatus !== "complete"}
              onClick={(e) => {
                e.preventDefault();
                handleCloseDialog();
                setOpenFinal(false);
              }}
            >
              Done
            </Button>
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <InfoDialog
        openInfo={openInfo}
        loading={
          payablePaymentLoading ||
          createChallengeLoading ||
          createPurchaseSessionLoading
        }
        setOpenInfo={setOpenInfo}
        info={info}
        setInfo={setInfo}
        handlePayment={handleNewCreate}
      />
    </div>
  );
}

export default BillingSummary;
const SocketIo = io(process.env.REACT_APP_BACKEND_URL + "/cryptochill", {
  reconnection: true,
  reconnectionDelay: 100000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 99999,
});
